import * as React from "react";
import { Link } from "react-router-dom";

import { Analytics, ResultCardSubHeading } from "@skv/core";
import { useViewModel } from "@skv/state";
import { pluraliser } from "@skv/util";

import {
  ResultCard,
  ResultCardHeader,
  ResultCardHeading,
} from "~/ui/ResultCard";

interface ExperienceResultCardProps {
  id: number;
  title: string;
  organisation: string;
  date: string;
  summary: string;
}

const ExperienceResultCard: React.FC<ExperienceResultCardProps> = ({
  id,
  title,
  organisation,
  date,
  summary,
}) => {
  return (
    <ResultCard className="py-4">
      <div className="d-flex mx-n3">
        <div className="px-3 flex-grow-1">
          <ResultCardHeader>
            <ResultCardHeading className="h1">{title}</ResultCardHeading>
            <ResultCardSubHeading className="h3">
              {organisation}
            </ResultCardSubHeading>
          </ResultCardHeader>
          <p>{summary}</p>
        </div>

        {/* TODO : Accessibility of these buttons */}
        {/* TODO : functionality of these buttons */}

        <div className="px-3 d-flex flex-column">
          <div className="mt-auto text-right mb-1">
            <Link
              type="button"
              className="btn btn-link font-weight-bold"
              to={(loc) => ({
                pathname: `/my-activity/experience/${id}`,
                state: loc.state,
              })}
            >
              Edit
            </Link>
          </div>
        </div>
      </div>
    </ResultCard>
  );
};

interface ExperiencesViewModel {
  experienceCount: number;
  experiences: Experience[];
}

interface Experience {
  dateCreated: string;
  description: string;
  id: number;
  organisation: string;
  title: string;
  when: string;
}

export const Experiences = () => {
  const [{ data, error, status }] = useViewModel<ExperiencesViewModel>();

  /* todo : loading? */
  if (status === "loading") {
    return <p className="mt-3">Loading, please wait...</p>;
  }

  /* todo : error */
  if (status === "error") {
    return <p>Error</p>;
  }

  return (
    <>
      <header>
        {/* TODO: create custom class? .myactivity-heading */}
        <h2
          className="display-3 font-weight-bold border-bottom mt-n2 mb-0"
          css={`
            padding-bottom: 1.25rem;
          `}
        >
          {pluraliser(data.experienceCount, {
            none: "You have not added any experiences",
            plural: `You have added ${data.experienceCount} experiences`,
            singular: "You have added 1 experience",
          })}
        </h2>
      </header>

      <ul className="list-unstyled">
        {data.experiences.map((n) => (
          <li key={n.id} className="my-0">
            <ExperienceResultCard
              id={n.id}
              date={n.when}
              organisation={n.organisation}
              summary={n.description}
              title={n.title}
            />
          </li>
        ))}
      </ul>
      <div className={data.experienceCount ? "" : "mt-5"}>
        <Link
          to={(loc) => ({
            pathname: "/my-activity/experience",
            state: loc.state,
          })}
        >
          <i
            tabIndex={-1}
            aria-hidden="true"
            className="material-icons nsw-material-icons mr-1 mb-1"
            css={`
              line-height: 0;
            `}
          >
            add
          </i>
          Add volunteer experience
        </Link>
      </div>

      <Analytics
        data={{
          subSection: "volunteers",
          subSubSection: "activity",
          subSubSubSection: "experiences",
          pageTitle: "experiences",
          loginStatus: "loggedin",
        }}
      />
    </>
  );
};
